import dagre from "dagre";
/**
 * Default layout options (30% larger spacing)
 */
const DEFAULT_LAYOUT_OPTIONS = {
    direction: "TB",
    nodeSpacing: 156,
    rankSpacing: 234,
};
/**
 * Get the width of a node based on its type (30% larger)
 */
export function getNodeWidth(nodeType) {
    switch (nodeType) {
        case "workspace":
            return 312;
        case "project":
            return 260;
        case "task":
            return 234;
        case "notification":
            return 260;
        default:
            return 234;
    }
}
/**
 * Get the height of a node based on its type (30% larger)
 */
export function getNodeHeight(nodeType) {
    switch (nodeType) {
        case "workspace":
            return 130;
        case "project":
            return 117;
        case "task":
            return 104;
        case "notification":
            return 117;
        default:
            return 104;
    }
}
/**
 * Calculate automatic layout for nodes using dagre hierarchical layout algorithm
 *
 * @param nodes - Array of flow nodes to position
 * @param edges - Array of edges defining relationships between nodes
 * @param options - Optional layout configuration
 * @returns Array of nodes with calculated positions
 */
export function calculateLayout(nodes, edges, options = {}) {
    // Return empty array if no nodes
    if (nodes.length === 0) {
        return [];
    }
    // Merge with default options
    const layoutOptions = {
        ...DEFAULT_LAYOUT_OPTIONS,
        ...options,
    };
    // Create a new directed graph
    const dagreGraph = new dagre.graphlib.Graph();
    // Set default edge label
    dagreGraph.setDefaultEdgeLabel(() => ({}));
    // Configure graph layout with top alignment
    dagreGraph.setGraph({
        rankdir: layoutOptions.direction,
        nodesep: layoutOptions.nodeSpacing,
        ranksep: layoutOptions.rankSpacing,
        marginx: 50,
        marginy: 50,
        align: "UL", // Align to upper-left for top-down layout
    });
    // Add nodes to dagre graph with their dimensions
    nodes.forEach((node) => {
        const nodeType = node.data.type;
        dagreGraph.setNode(node.id, {
            width: getNodeWidth(nodeType),
            height: getNodeHeight(nodeType),
        });
    });
    // Add edges to dagre graph
    edges.forEach((edge) => {
        dagreGraph.setEdge(edge.source, edge.target);
    });
    // Calculate layout
    dagre.layout(dagreGraph);
    // Apply calculated positions to nodes
    const layoutedNodes = nodes.map((node) => {
        const nodeWithPosition = dagreGraph.node(node.id);
        // dagre returns center position, but React Flow expects top-left
        // so we need to adjust by half the node dimensions
        const nodeType = node.data.type;
        const width = getNodeWidth(nodeType);
        const height = getNodeHeight(nodeType);
        return {
            ...node,
            position: {
                x: nodeWithPosition.x - width / 2,
                y: nodeWithPosition.y - height / 2,
            },
        };
    });
    return layoutedNodes;
}
